// Actie-tellers voor de zijbalk: per module het aantal dingen dat op jou wacht, zoals een ongelezen gesprek in WhatsApp.
// Elke teller is een goedkope telling (head-query). Ontbreekt een tabel, dan telt die module gewoon niet mee.
// kleur "rood" = er is iets kapot of te laat, "geel" = er wacht iets op jouw beslissing.
import { lees, vandaagIso } from "./gedeeld";
import { leesModusActief } from "./leesModus";

const DAG = 86400000;

const teller = async (query) => {
  try { const r = await query; return r.error ? 0 : (r.count || 0); } catch { return 0; }
};

// Zet ruwe getallen om in { moduleId: { n, kleur, tip } }. Los van de database zodat het te testen is.
export function bouwTellers(d) {
  const t = {};
  const zet = (id, n, kleur, tip) => { if (n > 0) t[id] = { n, kleur, tip }; };
  zet("goedkeuringen", d.wijzigingen, "geel", d.wijzigingen + " wijziging(en) wachten op jouw akkoord");
  zet("growth", d.growth, "geel", d.growth + " growth-review(s) wachten op jouw beoordeling");
  zet("operatie", d.sandboxFout, "rood", d.sandboxFout + " mislukte uitvoering(en) deze week");
  zet("klantenservice", d.tickets, "geel", d.tickets + " open klantvraag/vragen");
  zet("crm", d.aanvragenFout, "rood", d.aanvragenFout + " website-aanvraag/aanvragen niet verwerkt of niet gemaild");
  zet("facturatie", d.facturenTeLaat, "rood", d.facturenTeLaat + " factuur/facturen na vervaldatum");
  if (d.takenTeLaat > 0) zet("taken", d.takenTeLaat, "rood", d.takenTeLaat + " taak/taken te laat");
  else zet("taken", d.takenVandaag, "geel", d.takenVandaag + " taak/taken met deadline vandaag");
  zet("systeem", d.systeemProblemen.length, "rood", d.systeemProblemen.join(", "));
  return t;
}

export async function laadTellers(supabase) {
  const nu = new Date();
  const vandaag = vandaagIso();
  const week = new Date(nu.getTime() - 7 * DAG).toISOString();
  const kwartier = new Date(nu.getTime() - 15 * 60000).toISOString();
  const head = { count: "exact", head: true };

  const [wijzigingen, growth, sandboxFout, tickets, aanvragenFout, facturenTeLaat, takenTeLaat, takenVandaag, cron, uptime, meta, backup, koppelingen] = await Promise.all([
    teller(supabase.from("proposed_changes").select("id", head).in("status", ["pending", "approved"])),
    teller(supabase.from("growth_reviews").select("id", head).eq("status", "pending")),
    teller(supabase.from("sandbox_runs").select("id", head).eq("status", "failed").gte("started_at", week)),
    teller(supabase.from("klantenservice_tickets").select("id", head).in("status", ["open", "concept_klaar"])),
    teller(supabase.from("website_aanvragen").select("id", head).or("crm_fout.not.is.null,and(gemaild_op.is.null,created_at.lt." + kwartier + ")")),
    teller(supabase.from("admin_docs").select("id", head).eq("payment_status", "open").not("vervaldatum", "is", null).lt("vervaldatum", vandaag)),
    teller(supabase.from("tasks").select("id", head).neq("status", "done").lt("due", vandaag)),
    teller(supabase.from("tasks").select("id", head).neq("status", "done").eq("due", vandaag)),
    supabase.rpc("systeem_cron_status").then((r) => r, () => ({ data: [] })),
    lees(supabase.from("uptime_checks").select("dienst,ok,checked_at").gte("checked_at", new Date(nu.getTime() - 2 * DAG).toISOString()).order("checked_at", { ascending: false }).limit(300)),
    lees(supabase.from("meta_ads_accounts").select("token_status")),
    lees(supabase.from("app_settings").select("value").eq("key", "laatste_backup_download")),
    supabase.rpc("systeem_koppelingen").then((r) => r, () => ({ data: [] })),
  ]);

  const systeemProblemen = [];
  const cronKapot = (cron.data || []).filter((c) => c.active && (c.laatste_status === "failed" || Number(c.fouten_24u) > 0)).length;
  if (cronKapot) systeemProblemen.push(cronKapot + " geplande taak/taken met fouten");
  const gezien = new Set();
  let down = 0;
  uptime.data.forEach((x) => { if (!gezien.has(x.dienst)) { gezien.add(x.dienst); if (!x.ok) down++; } });
  if (down) systeemProblemen.push(down + " dienst(en) niet bereikbaar");
  if (meta.data.some((m) => m.token_status && m.token_status !== "ok")) systeemProblemen.push("advertentie-token werkt niet meer");
  const kapot = (Array.isArray(koppelingen && koppelingen.data) ? koppelingen.data : []).filter((k) => k.status === "stuk");
  kapot.forEach((k) => systeemProblemen.push(k.naam + " werkt niet"));
  const laatste = backup.data[0] && backup.data[0].value;
  // Een gast met leesrechten (Tristan) kan app_settings niet lezen: dan is "geen datum" geen bewijs dat er geen back-up is.
  if (!leesModusActief() && (!laatste || (nu.getTime() - new Date(laatste).getTime()) / DAG > 14)) systeemProblemen.push("back-up ouder dan 14 dagen");

  return bouwTellers({ wijzigingen, growth, sandboxFout, tickets, aanvragenFout, facturenTeLaat, takenTeLaat, takenVandaag, systeemProblemen });
}
